/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {KTableProvider, useKTable} from '../../../../../../../../contexts/KTableProvider'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../../../components/UI'
import {FC, useCallback, useEffect, useMemo, useState} from 'react'
import {KTCard} from '../../../../../../../../../../_metronic/helpers'
import {
  getLaundryCostDetailReportPDF,
  getLaundryCostDetailReportXLS,
  getLaundryCostDetailReportCSV,
  getLaundryCostDetailById,
} from '../../../../../../services'
import {useLavanderia} from '../../../../../../../../hooks/useLavanderia'
import {ButtonWrapper, DrawerReport} from '../../../../../../../../components/UI/Button'
import {LaundryCostModel} from '../../../../../../features/laundryBilling/model/laundryBilling.model'
import {donwloadFile} from '../../../../../../helpers/utilities'

const downloadReportForType = {
  pdf: getLaundryCostDetailReportPDF,
  xlsx: getLaundryCostDetailReportXLS,
  csv: getLaundryCostDetailReportCSV,
}

type TypeDownloadReport = keyof typeof downloadReportForType

const TableLaundryCost: FC = () => {
  const {data, setData, setPagination, loading, setLoading, pagination} = useKTable()
  const {currentTabItem, isAllowed} = useLavanderia()
  const [isDownload, setIsDownload] = useState<boolean>(false)

  const getLaundryList = useCallback(
    async (props: any = {}) => {
      setLoading(true)
      try {
        const response = await getLaundryCostDetailById(
          currentTabItem.idToEdit,
          pagination.currentPage,
        )
        const dataInfo = response.data?.data || []
        setData(dataInfo)
        setPagination({
          ...pagination,
          totalResults: response.data.total,
        })
      } catch (error) {
        console.log(error)
      }
      setLoading(false)
    },
    [setLoading, setData, pagination.currentPage],
  )
  const handleDownloadReport = async (typeFormat: TypeDownloadReport) => {
    try {
      setIsDownload(true)
      const response = await downloadReportForType[typeFormat](currentTabItem.idToEdit)
      await donwloadFile(response.data, typeFormat)
      setIsDownload(false)
    } catch (error) {
      setIsDownload(false)
    }
  }

  const columns: Column<LaundryCostModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} title='Empresa' />,
        accessor: 'empresa',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Centro de costo' />,
        accessor: 'centroCostos',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Peso (Kg.)' />,
        accessor: 'totalKg',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Total (S/.)' />,
        accessor: 'TotalPrecio',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Total de prendas' />,
        accessor: 'totalPrendas',
      },
    ],
    [],
  )
  useEffect(() => {
    getLaundryList()
  }, [pagination.currentPage])

  const dataDownloadReport = [
    {
      text: 'Descargar como PDF',
      report: () => handleDownloadReport('pdf'),
    },
    {
      text: 'Descargar como XLSX',
      report: () => handleDownloadReport('xlsx'),
    },
    {
      text: 'Descargar como CSV',
      report: () => handleDownloadReport('csv'),
    },
  ]
  return (
    <>
      <KTCard shadow className='m-5'>
        {isAllowed('CECO/EXPORTAR') && (
          <div className='p-2'>
            <div className='row'>
              <ButtonWrapper className='sdx-white-bg overflow-visible justify-content-end'>
                <DrawerReport data={dataDownloadReport} loading={isDownload} />
              </ButtonWrapper>
            </div>
          </div>
        )}
        {isAllowed('CECO/LISTAR') && (
          <>
            <KTable data={data} columns={columns} />
            {loading ? <KTableLoading title='Cargando...' /> : null}
          </>
        )}
      </KTCard>
    </>
  )
}

const TableLaundryCostWrapper = () => {
  return (
    <KTableProvider>
      <TableLaundryCost />
    </KTableProvider>
  )
}
export {TableLaundryCostWrapper}
